<footer class="dip">
  <div class="dip-ic">
    <div>
      <a class="logo" routerLink="/"><svg><use xlink:href="#lg"></use></svg> pratiu</a>
      <p>Kazanım temelli öğrenmeyi hedefleyen, bilgiyi sürekli taze tutan; eğitim ekosistemindeki tüm paydaşların kolaylıkla kullanabileceği yeni nesil bir eğitim platformu.</p>
    </div>
    <!--
    <div>
      <h5>Çözümler</h5>
      <ul>
        <li><a routerLink="/education-institutions">Eğitim Kurumları</a></li>
        <li><a routerLink="/corporates">Kurumsal Firmalar</a></li>
        <li><a routerLink="/teachers">Öğretmenler</a></li>
        <li><a routerLink="/students">Öğrenci / Veli</a></li>
      </ul>
    </div>
    <div>
      <h5>Soru havuzu</h5>
      <ul>
        <li><a routerLink="/" fragment="sinav">LGS hazır sorular</a></li>
        <li><a routerLink="/" fragment="sinav">YKS · TYT</a></li>
        <li><a routerLink="/" fragment="sinav">YKS · AYT</a></li>
        <li><a href="https://app.pratiu.com" target="_blank" rel="noopener">Soru bankası</a></li>
      </ul>
    </div>
    <div>
      <h5>Kurumsal</h5>
      <ul>
        <li><a routerLink="/aboutus">Hakkımızda</a></li>
        <li><a routerLink="/privacy">Gizlilik</a></li>
        <li><a routerLink="/termsconditions">Kullanım Şartları</a></li>
        <li><a routerLink="/contact">İletişim</a></li>
      </ul>
    </div>
    -->
  </div>
  <div class="dip-alt">
    <span>© 2026 pratiu</span>
    <a href="mailto:help@pratiu.com">help@pratiu.com</a>
  </div>
</footer>
